import { Fragment, useEffect, useState, useContext } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Typography, Box, Table, TableHead, TableRow, TableCell, TableBody, Container, Paper, Breadcrumbs, TableContainer, Link, TextField } from '@mui/material';
import { useToaster } from '../../../../providers/ToasterProvider';

import { createFromFile, deleteAll, getDataForFeedbackDashboard } from '../../../../services/feedbackQuestionService';
import { ContentUploadErrorsModal } from '../ContentUploadErrorsModal/ContentUploadErrorsModal'

import DELETE from '../../../../assets/images/action-delete.svg';
import RadiusButton from '../../../../components/RadiusButton';
import { LoadingButton } from '@mui/lab';

import { ProjectContext } from '../../../../providers/projectProvider';

import { MainContainer } from '../../../../components';
import { Menu } from '../Menu/Menu';

import ARROW from '../../../../assets/images/breadcrumb-arrow.svg';
import ARROW_OPEN from '../../../../assets/images/breadcrumb-arrow-open.svg';
import ARROW_LEFT from '../../../../assets/images/back.svg';
import XLS from '../../../../assets/images/docx.svg';
import { downloadFeedbackTemplate } from '../../../../services/configurationService';


export const FeedbackUpload = () => {

    const params = useParams();
    const projectName = params?.projectName;
    const location = useLocation();
    const { projectDetails } = useContext(ProjectContext);
    const [drive, setDrive] = useState({
        id: null,
        driveName: 'Drive name'
    });
    const [course, setCourse] = useState({
        id: null,
        courseName: 'Course name'
    });
    const navigate = useNavigate();
    const [configurationId, setConfigurationId] = useState(null);
    const [numberOfFeedbackQuestions, setNumberOfFeedbackQuestions] = useState(null);
    const [fileDetails, setFileDetails] = useState({
        file: null,
        language: null
    });
    const [errorModal, setErrorModal] = useState({
        isVisible: false,
        errors: []
    });
    const [languages, setLanguages] = useState([]);
    const [recordsUpdated, setRecordsUpdated] = useState(false);
    const { addNotification } = useToaster();
    const [isUploading, setIsUploading] = useState(false);

    const onGoToMasters = () => {
        if (projectName) {
            navigate(`/${projectName}/masters`);
        }
    }

    useEffect(() => {
        const driveDetails = location?.state?.drive;
        const courseDetails = location?.state?.course;
        const configurationId = location?.state?.configurationId;
        if (!driveDetails || !courseDetails || !configurationId) {
            onGoToMasters();
        } else {
            setDrive(() => driveDetails);
            setCourse(() => courseDetails);
            setConfigurationId(configurationId);
            const fetchDetails = async () => {
                try {
                    const res = await getDataForFeedbackDashboard(configurationId);
                    if (res.code === 'OK') {
                        setNumberOfFeedbackQuestions(res.data.numberOfFeedbackQuestions);
                        setLanguages(res.data.languageGroups.map((lan) => {
                            lan.count = Number(lan.count);
                            return lan;
                        }));
                    }
                } catch (error) {
                    console.log('There is an error while getting feedback questions.', error);
                }
            }
            fetchDetails();
        }
    }, [location, recordsUpdated]);

    const handleFileDrop = (e, language) => {
        const inputFile = e.target.files?.[0];
        if (fileDetails?.file && fileDetails.language) {
            const ele = document.getElementById(`file_${fileDetails.language}`);
            if (ele) {
                ele.value = '';
            }
        }
        if (inputFile && inputFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            setFileDetails({
                file: inputFile,
                language: language,
            })
        }
    }
    const handleRemoveFile = () => {
        const language = fileDetails.language;
        if (language) {
            document.getElementById(`file_${language}`).value = '';
            setFileDetails({
                file: null,
                language: null
            });
        }
    }
    const handleFeedbackUpload = async () => {
        if (fileDetails?.file && fileDetails?.language && configurationId) {
            setIsUploading(true);
            try {
                const body = new FormData();
                body.append('configurationId', configurationId);
                body.append('language', fileDetails.language);
                body.append('file', fileDetails.file);
                const res = await createFromFile(body);

                if (res.code === 'E_BAD_REQUEST') {
                    addNotification('Invalid data in file data', 'danger');
                    setErrorModal({
                        ...errorModal,
                        isVisible: true,
                        errors: res.data.errors,
                    });
                } else {
                    const maxQuestionNo = res.data?.maxQuestionNo;
                    if (maxQuestionNo > numberOfFeedbackQuestions) {
                        addNotification(`There are ${maxQuestionNo} Questions in file we have uploaded first ${numberOfFeedbackQuestions} questions only.`, 'success');
                    } else {
                        addNotification('Questions uploaded successfully.', 'success');
                    }
                    setRecordsUpdated(!recordsUpdated);
                    document.getElementById(`file_${fileDetails.language}`).value = '';
                    setFileDetails({
                        file: null,
                        language: null
                    });
                }

            } catch (error) {
                const code = error?.response?.data?.code;
                if (code === 'WORD_FILE_NO_MATCHING_FIELDS') {
                    addNotification('File has no matching fields.', 'danger');
                } else if (code === 'WORD_FILE_MISSING_FIELDS') {
                    addNotification('File has no data.', 'danger');
                } else {
                    addNotification('File does not uploaded', 'danger');
                }
                console.log('There is an error while uploading file set wise', error);
            } finally {
                setIsUploading(false);
            }
        }
    }
    const handlePreview = (index) => {
        const language = languages[index];
        console.log('language', language);
        if (language && projectName) {
            navigate(`/${projectName}/feedback-preview`, {
                state: {
                    drive: drive,
                    course: course,
                    configurationId: configurationId,
                    questionNo: 1,
                    maxQuestions: language.count,
                    language: language.language
                }
            });
        }
    }
    const handleDeleteAll = async (language) => {
        if (configurationId && language) {
            try {
                const res = await deleteAll({
                    configurationId: configurationId,
                    language: language
                });
                if (res.code === 'OK') {
                    setRecordsUpdated(!recordsUpdated);
                    addNotification('Feedback questions deleted successfully.', 'success');
                }
            } catch (error) {
                const code = error?.response?.data?.code;
                if (code === 'E_EXAM_LOCKED') {
                    addNotification('Exam is locked.', 'danger');
                }
                console.log('There is an error while deleteing feedback questions', error);
            }
        }
    }

    const onDownloadFeedbackTemplate = async () => {
        try {
            const res = await downloadFeedbackTemplate();
            const url = window.URL.createObjectURL(res);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `feedback-template.docx`,
            );
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            addNotification('File downloaded successfully.', 'success');
        } catch (error) {
            console.log('error', error);
            addNotification('Unexpected error occurred', 'danger');
        }
    }

    return (
        <MainContainer>
            <Menu>
                <Breadcrumbs aria-label="breadcrumb" separator='' sx={{ gap: 12 }}>
                    <Typography sx={{ fontWeight: 400, textTransform: 'capitalize' }}>{projectDetails?.projectName}</Typography>
                    <Box sx={{ display: 'flex', alignContent: 'center' }}>
                        <img src={ARROW} alt=''></img>
                    </Box>

                    <Typography color="text.primary" sx={{ fontWeight: 500, textTransform: 'capitalize' }}>Feedback Upload</Typography>
                    <Box sx={{ display: 'flex', alignContent: 'center' }}>
                        <img src={ARROW_OPEN} alt='' ></img>
                    </Box>
                </Breadcrumbs>
            </Menu>
            <Container sx={{
                display: 'flex',
                flexDirection: 'column',
                height: 'calc(100vh - 100px)',
            }}>
                <div className="search-header-wrapper" sx={{ mb: 1.5 }}>
                    <h1 className='title' style={{
                        margin: '0px',
                        marginRight: 'auto',
                        textTransform: 'capitalize'
                    }}>Feedback Upload</h1>
                </div>

                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    columnGap: 2,
                    rowGap: 0.5,
                    mb: 3
                }}>
                    <TextField
                        label="Drive Name"
                        variant="outlined"
                        value={drive?.['driveName']}
                        disabled
                        InputLabelProps={{
                            shrink: true
                        }}
                        sx={{
                            width: 238,
                            bgcolor: 'background.base'
                        }}
                    />
                    <TextField
                        label="Course Name"
                        variant="outlined"
                        value={course?.['courseName']}
                        disabled
                        InputLabelProps={{
                            shrink: true
                        }}
                        sx={{
                            width: 238,
                            bgcolor: 'background.base'
                        }}
                    />
                    <RadiusButton
                        variant='contained'
                        color='grey'
                        sx={{ ml: 'auto' }}
                        onClick={onGoToMasters}
                        startIcon={<img src={ARROW_LEFT} alt='' />}
                    >
                        Go back
                    </RadiusButton>
                    <RadiusButton
                        variant='contained'
                        color='secondary'
                        startIcon={<img style={{width: '24px'}} src={XLS} alt='' />}
                        onClick={onDownloadFeedbackTemplate}
                    >
                        Download Feedback Template
                    </RadiusButton>
                </Box>

                <Paper sx={{
                    borderRadius: 3,
                    bgcolor: 'background.base',
                    flex: 1,
                    maxWidth: 'calc(100vw - 140px)',
                    overflow: 'auto',
                }}>
                    <TableContainer sx={{
                        p: 2,
                        maxHeight: 'inherit',
                        maxWidth: 'inherit',
                        borderRadius: 1
                    }}>
                        <Table stickyHeader aria-label="table">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        align='left'
                                        style={{ width: 200 }}
                                        sx={{ border: 'none', p: 0 }}
                                    ></TableCell>
                                    <TableCell
                                        align='left'
                                        style={{ minWidth: 320 }}
                                        sx={{ border: 'none', p: 0 }}
                                    ></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {languages?.map((lan, index) => {
                                    return <TableRow key={index}>
                                        <TableCell sx={{ border: 'none', verticalAlign: 'top' }}>
                                            <Typography
                                                component='span'
                                                variant='subtitle1'
                                                sx={{ textTransform: 'capitalize' }}
                                            >{lan?.language}</Typography>
                                        </TableCell>
                                        <TableCell sx={{
                                            border: 'none',
                                            flex: 1,
                                            p: 0,
                                        }}>
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                flexDirection: 'column',
                                                gap: 1.5,
                                                py: 1.5,
                                                backgroundColor: 'grey.100',
                                                px: 2.5,
                                                borderRadius: 2,
                                                mb: 1
                                            }}>
                                                <Typography
                                                    variant='subtitle1'
                                                    component='h6'
                                                >
                                                    Uploaded ({lan.count} / {numberOfFeedbackQuestions})
                                                </Typography>
                                                {lan.count === 0 && (
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                        height: 24,

                                                    }}>
                                                        <Link
                                                            sx={{
                                                                fontSize: 14,
                                                                fontWeight: 500,
                                                                cursor: 'pointer',
                                                            }}
                                                            component='label'
                                                            htmlFor={`file_${lan.language}`}
                                                        >Select file</Link>
                                                        <input
                                                            style={{ display: 'none' }}
                                                            type='file'
                                                            id={`file_${lan.language}`}
                                                            onChange={(e) => handleFileDrop(e, lan.language)}
                                                            accept='application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                                                        />
                                                        {
                                                            fileDetails?.language === lan.language && fileDetails?.file && fileDetails?.file?.name
                                                                ? (
                                                                    <>
                                                                        <Box component='span'>{fileDetails.file.name}</Box>
                                                                        <img
                                                                            style={{ cursor: 'pointer' }}
                                                                            src={DELETE}
                                                                            onClick={handleRemoveFile}
                                                                            alt=''
                                                                        />
                                                                    </>
                                                                ) : null
                                                        }
                                                    </Box>
                                                )}
                                                <Box sx={{
                                                    display: 'flex',
                                                    gap: 1,
                                                    alignItems: 'center',
                                                }}>

                                                    {fileDetails?.language === lan.language && fileDetails?.file && <LoadingButton
                                                        sx={{ borderRadius: 40, textTransform: 'capitalize' }}
                                                        variant='contained'
                                                        color='primary'
                                                        onClick={handleFeedbackUpload}
                                                        loading={isUploading}
                                                    >Upload</LoadingButton>}
                                                    {lan?.count > 0 && <>
                                                        <RadiusButton
                                                            variant='contained'
                                                            color='primary'
                                                            onClick={() => handlePreview(index)}
                                                        >Preview</RadiusButton>
                                                    </>}
                                                    {lan?.count > 0 && <RadiusButton
                                                        variant='contained'
                                                        color='secondary'
                                                        onClick={() => handleDeleteAll(lan.language)}
                                                    >Delete All</RadiusButton>}
                                                </Box>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <ContentUploadErrorsModal currentState={errorModal} setCurrentState={setErrorModal}></ContentUploadErrorsModal>
                </Paper>
            </Container>
        </MainContainer >
    );
}